// extracted by mini-css-extract-plugin
export default {"DashboardFolders":"DashboardFolders_DashboardFolders__lDkjV","tabHeader":"DashboardFolders_tabHeader__bgLv-"};